import React, { useState } from 'react';
import EnterpriseLeftSidebar from './EnterpriseLeftSidebar';
import EnterpriseHeader from './EnterpriseHeader';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div data-testid="layout-container" className="flex h-screen bg-gray-50">
      {/* Enterprise Left Sidebar */}
      <EnterpriseLeftSidebar isOpen={sidebarOpen} onClose={closeSidebar} />

      {/* Main content area */}
      <div data-testid="main-content-area" className="flex flex-col flex-1 overflow-hidden lg:ml-72">
        {/* Top Header */}
        <EnterpriseHeader onToggleSidebar={toggleSidebar} />

        {/* Main content */}
        <main data-testid="main-content" className="flex-1 overflow-y-auto bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;